import classNames from "classnames";
import CheckIcon from "@mui/icons-material/Check";

export default function PiCheckbox(props: {
  checked: boolean;
  onToggle: (checked: boolean) => void;
  shape?: "square" | "rounded";
  disabled?: boolean;
  testId?: string;
  /** "sm" is for dense surfaces like the 250px properties column. */
  size?: "sm" | "md";
}) {
  const {
    checked,
    onToggle,
    shape = "square",
    disabled = false,
    testId,
    size = "md",
  } = props;

  return (
    <div
      className={classNames({
        "flex justify-center items-center flex-shrink-0": true,
        "w-[20px] h-[20px]": size === "md",
        "w-[15px] h-[15px]": size === "sm",
        "cursor-pointer": !disabled,
        "cursor-not-allowed opacity-50": disabled,
        "text-[16px]": size === "md",
        "text-[12px]": size === "sm",
        "text-white bg-creator-primary hover:bg-creator-primary-hover":
          checked && !disabled,
        "text-white bg-creator-primary": checked && disabled,
        "border-solid border-creator-primary": !checked && !disabled,
        "border-solid border-creator-border": !checked && disabled,
        // A 2px rule reads as a heavy outline once the box is only 15px.
        "border-2": !checked && size === "md",
        "border-[1.5px]": !checked && size === "sm",
        "rounded-[5px]": shape === "square" && size === "md",
        "rounded-[4px]": shape === "square" && size === "sm",
        "rounded-full": shape === "rounded",
      })}
      onClick={() => !disabled && onToggle(!checked)}
      data-testid={testId}
    >
      {checked && <CheckIcon color="inherit" fontSize="inherit" />}
    </div>
  );
}
